import type { FirebaseStorage } from 'firebase/storage'
import { getDownloadURL, ref } from 'firebase/storage'

/**
 * Check whether a URL is a GCS V4 signed URL.
 * Signed URLs contain an X-Goog-Signature query parameter.
 */
export function isSignedUrl(url: string | undefined | null): boolean {
  if (!url) return false
  return url.includes('X-Goog-Signature=')
}

/**
 * Resolve a storage URL to a downloadable URL.
 * If the URL is already signed (from the API), return it directly.
 * Otherwise, use getDownloadURL to get a token-authenticated URL.
 */
export async function resolveStorageUrl(
  storage: FirebaseStorage,
  url: string
): Promise<string> {
  if (isSignedUrl(url)) return url
  const fileRef = ref(storage, url)
  return getDownloadURL(fileRef)
}

export async function decodeStorageUrl(storage: FirebaseStorage, url: string) {
  if (isSignedUrl(url)) return url

  const path = url.split('appspot.com/o/').pop()?.split('?').shift()
  const unescapedPath = decodeURIComponent(path || '')

  const fileRef = ref(storage, unescapedPath)
  const fileUrl = await getDownloadURL(fileRef)
  return fileUrl
}
